import { z } from "zod";

export const messageStatusSchema = z.object({
	message: z.string().nullable(),
	status: z.literal("PASS"),
	resolution: z.string().nullable(),
	code: z.string().nullable(),
});

export const contactSchema = z.object({
	phone: z.string(),
	tollFree: z.string(),
});

export const dataGroupSchema = z.object({
	expirationDate: z.string(), // You can use z.coerce.date() if you want to parse to Date
	releaseDate: z.string(),
	name: z.string(),
	supportId: z.string(),
});

export const terminalSchema = z.object({
	serviceCode: z.string(),
	terminalName: z.string(),
	serviceMethod: z.string(),
	serviceType: z.string(),
	code: z.string(),
	address1: z.string(),
	address2: z.string().nullable(),
	city: z.string(),
	stateProvince: z.string(),
	postalCode: z.string(),
	countryCode: z.string(),
	contact: contactSchema,
	dataGroup: dataGroupSchema,
});

export const terminalResponseSchema = z.object({
	messageStatus: messageStatusSchema,
	carrierName: z.string(),
	scac: z.string(),
	serviceMethod: z.string(),
	terminals: z.array(terminalSchema),
});

export type Terminal = z.infer<typeof terminalSchema>;
export type TerminalResponse = z.infer<typeof terminalResponseSchema>;
